import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBasic, TextButton } from "src/components";
import Checkbox from "src/components/Checkbox/Checkbox";
import { selectOrgData } from "src/store/projectSelectors";
import { convertStrToBool } from "src/utils/common-utils";
import WhatsNextModal from "./WhatsNextModal";
import { setTrackerModalShow } from "src/store/trackerSlice";

const SummaryCopy = ({ track, evidenceRate, isVerified }) => {
  const [confirmed, setConfirmed] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const userData = useSelector(selectOrgData);

  const openModal = () => {
    setShowModal(true);
  };

  const dispatch = useDispatch();

  const openTracker = () => {
    dispatch(setTrackerModalShow(true));
  };

  return (
    <>
      {track === "self-assessment" ? (
        <div className="text-center mb-3">
          <p
            style={{
              fontSize: "20px",
            }}
          >
            Congratulations on completing your ESG self-assessment with
            ZeroBees!
          </p>
          <p>
            Below is an indication of your current ESG maturity based on the
            answers you have provided.
          </p>
          <ButtonBasic
            size="lg"
            bgcolor="green"
            hovercolor="darkgreen"
            onClick={openModal}
            active
            tabIndex={-1}
          >
            What's Next?
          </ButtonBasic>
        </div>
      ) : (
        <div className="text-center mb-3">
          <p
            style={{
              fontSize: "20px",
            }}
            className="mb-1"
          >
            You've currently provided{" "}
            <TextButton
              className="text-info"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
              onClick={openTracker}
            >
              evidence
            </TextButton>{" "}
            for <b>{evidenceRate}%</b> of the required questions,
          </p>
          <p
            style={{
              fontSize: "20px",
            }}
          >
            for the period from{" "}
            <b>
              {userData?.periodFrom} to {userData?.periodTo}
            </b>
            .
          </p>
          {isVerified ? (
            <>
              <p>
                Your ESG score for the period {userData?.periodFrom} to{" "}
                {userData?.periodTo} is validated.
              </p>
              <p>
                The full breakdown on your validated scores is below. Please
                look at the "next steps" to plan your improvement pathway for
                the coming year.
              </p>
            </>
          ) : (
            <>
              <p>
                Please confirm that you're happy with the answers and evidence
                you've submitted in order to proceed to verification.
              </p>
              <Checkbox
                style={{
                  fontSize: "16px",
                }}
                className=" mb-4"
                name="confirmed"
                id="confirmed"
                label="I'm happy with the answers and evidence I've submitted"
                onChange={(e) => {
                  const val = convertStrToBool(e.target.checked);
                  setConfirmed(val);
                }}
                value={confirmed}
              />
            </>
          )}
          <ButtonBasic
            size="lg"
            bgcolor="green"
            hovercolor="darkgreen"
            disabled={!confirmed && !isVerified}
            onClick={openModal}
            active
            tabIndex={-1}
          >
            What's Next?
          </ButtonBasic>
        </div>
      )}
      <WhatsNextModal
        track={track}
        show={showModal}
        onClose={() => setShowModal(false)}
        isVerified={isVerified}
      />
    </>
  );
};

export default SummaryCopy;
